// src/utils/generateFontFaces.js

const GenerateFontFaces = (fonts) => {
    return fonts.map(font => {
      const fontName = font.split('.')[0];
      const fontFormat = font.split('.').pop();
      const format = fontFormat === 'woff2' ? 'woff2' : 'woff';
  
      return `
        @font-face {
          font-family: '${fontName}';
          src: url('/assets/fonts/teedexFontsFiles/${font}') format('${format}');
          font-weight: normal;
          font-style: normal;
        }
      `;
    }).join('');
  };
  
  export default GenerateFontFaces;
  